module.exports =
  methods:
    bubbleUp: (data) ->
      if data.event and data.event.originalEventName
        @$emit data.event.originalEventName, data
      else
        console.warn 'bubbleUp method requires data.event.originalEventName to work properly'

    redirectIfNotOwner: (object) ->
      user_id = object.user_id || object.user.id
      if Session.current_user.isSeller() && user_id != Session.current_user.id
        @$router.push('/')

    goTo: (path, options={}) ->
      @$router.push(path)
      if options.success
        alertify.success(options.success)
      else if options.error
        alertify.success(options.error)





// WEBPACK FOOTER //
// ./src/global_mixin.coffee